import { RedirectingStepProps, StepProps } from '../steps/types';

const isRedirectingStep = (
  props: StepProps | RedirectingStepProps
): props is RedirectingStepProps => {
  return 'redirectToNodeType' in props;
};
export default isRedirectingStep;
